export default
'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 85 85" xml:space="preserve">' +
'<path d="M42.5,0C19,0,0,19,0,42.5S19,85,42.5,85S85,66,85,42.5S66,0,42.5,0z M46.5,66l-7.2-16.4l-2.6,4V66H24.5V19h12.3V37h0.1' +
'L46,19H59L47.2,39.5L60.5,66H46.5z"/>' +
'</svg>';
